jQuery( document ).ready(async function() {
    await setTimeout(() => {
        $('.pplr-btn').text("Personalizar")
         //jQuery('.productForm').after(jQuery('.pplr-btn'))
         //jQuery('#shop-bar .pplr-btn').hide()    
    }, 1100);
    });
    
    
    